// Shared, token-only style pieces for the builders-modern wizard chrome
// (WizardHeader / WizardIdentityStrip / WizardTotalBar —
// docs/mockups/builders-modern-2026-09-27.html Direction B; the web-only
// BuilderSummaryRail this once also served was retired 2026-09-28 when the
// web builders dropped the side rail for a single-card + footer layout).
// Extracted to its own module so these components import one small,
// reviewable set of constants instead of each re-deriving the same tokens.
import { foundation } from '../../../ui';

const { color, radii, spacePx, fontSize, fontWeight, fontFamily } = foundation;

/** Icon tile size shared by every wizard header (WizardHeader.js). */
export const WIZARD_ICON_TILE_SIZE = 32;

/**
 * Brand-tinted icon tile — the same 32px / radii.md shape every wizard uses.
 * The existing transfer-wizard modals (RouteOverrideModal.js,
 * BulkRouteOverrideModal.js) each hand-pick a bespoke tint per modal
 * (`titleIconStyle` — a hardcoded teal rgba/hex, pre-existing, out of scope
 * here); WizardHeader's own signature has no `iconStyle` prop, so it bakes in
 * ONE brand-token tile instead, giving the builders/unscheduled-visit wizards
 * a consistent look with zero per-consumer wiring.
 */
export const wizardIconTileStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: WIZARD_ICON_TILE_SIZE,
  height: WIZARD_ICON_TILE_SIZE,
  borderRadius: radii.md,
  background: color.brand.primaryMuted,
  color: color.brand.text,
  flexShrink: 0,
};

/** Quiet "Change" link beside the identity strip (WizardIdentityStrip.js). */
export const wizardChangeLinkStyle = {
  flexShrink: 0,
  background: 'none',
  border: 'none',
  padding: `${spacePx[2]} ${spacePx[1]}`,
  minHeight: 44,
  color: color.brand.text,
  fontSize: fontSize.sm,
  fontWeight: fontWeight.semibold,
  fontFamily: fontFamily.sans,
  cursor: 'pointer',
  WebkitTapHighlightColor: 'transparent',
};

export const wizardChipRowStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: spacePx[2],
};

/**
 * Period/project chip — jumps back to the field it names
 * (WizardIdentityStrip.js). Sized like FormProblemChips' own jump chips
 * (28-32px, not the 44px CTA floor) — that component is the established
 * precedent for "a small pill that jumps to a field", and it does not blow
 * its chips up to 44px either.
 */
export function wizardChipStyle({ hover = false } = {}) {
  return {
    display: 'inline-flex',
    alignItems: 'center',
    gap: spacePx[1],
    height: 30,
    padding: `0 ${spacePx[3]}`,
    borderRadius: radii.full,
    background: color.neutral.surface,
    border: `1px solid ${hover ? color.brand.primaryHover : color.neutral.border}`,
    color: hover ? color.brand.text : color.neutral.textSecondary,
    fontSize: fontSize.xs,
    fontWeight: fontWeight.semibold,
    fontFamily: fontFamily.sans,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'border-color 150ms ease, color 150ms ease',
    WebkitTapHighlightColor: 'transparent',
  };
}
